module.exports = __webpack_public_path__ + "static/img/manual_ja_4.cc9f127.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_4.png
// module id = WcDn
// module chunks = 4